import { Alert, Button, Collapse, Container, CopyButton, Group, Text } from "@mantine/core";
import FirestoreIndexError from "./FirestoreIndexError";
import { IconExclamationCircleFilled } from "@tabler/icons-react";
import { useDisclosure } from "@mantine/hooks";
import { COLORS } from "../../../constants/colorConstants";
import { processFirestoreError } from "../../../utils/firestoreErrors";

export default function ErrorCard({ error }) {
  const [opened, { toggle }] = useDisclosure(false);

  const firebaseError = processFirestoreError(error);

  if (firebaseError?.indexUrl) {
    return <FirestoreIndexError error={firebaseError} />;
  }

  const toggleLabel = opened ? "Hide Technical Details" : "Show Technical Details";

  return (
    <Container>
      <Alert variant="filled" color={COLORS.DARK_WINE} radius="xl" title="Error" icon={<IconExclamationCircleFilled />}>
        <Text style={{ marginBottom: 40, whiteSpace: "pre-wrap" }}>{error.message}</Text>
        <Group>
          <Button onClick={toggle} variant="white" c={COLORS.DARK_WINE}>
            {toggleLabel}
          </Button>
          <CopyButton value={error.stack}>
            {({ copied, copy }) => (
              <Button variant="white" color={copied ? "green" : "black"} onClick={copy}>
                Copy to Clipboard
              </Button>
            )}
          </CopyButton>
          <Collapse in={opened} transitionDuration={200} transitionTimingFunction="linear">
            <Text>{error.stack}</Text>
          </Collapse>
        </Group>
      </Alert>
    </Container>
  );
}
